import {
  Component,
  Input,
  Output,
  HostBinding,
  EventEmitter
} from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
    selector: 'app-whats-new-item',
    templateUrl: './whats-new-item.component.html',
    styleUrls: ['./whats-new-item.component.scss'],
    standalone: false
})
export class WhatsNewItemComponent {
  @Input()
  public readonly title: string;

  @Input()
  public readonly buttons: { id: string; text: string }[] = [];

  @Input()
  public animationOrder?: number = -1;

  @Output()
  public buttonClicked = new EventEmitter<string>();

  @HostBinding('style')
  get myStyle(): SafeStyle {
    return this._sanitizer.bypassSecurityTrustStyle(
      `--animation-order: ${this.animationOrder};`
    );
  }

  @HostBinding('class.animated')
  public get isAnimated() {
    return this.animationOrder !== -1;
  }

  public constructor(private readonly _sanitizer: DomSanitizer) {}

  protected onButtonClick(id: string) {
    this.buttonClicked.emit(id);
  }
}
